// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '@hotwired/turbo-rails'
import * as ActiveStorage from "@rails/activestorage"

require('chart.js')
require('chartkick')
require('@rails/ujs').start()

// Modules
import('./modules/bootstrap')

// Classes
import('./classes/notes')
import('./classes/status')
import('./classes/subscriptions/temporary_number')

import 'controllers'
